/**
 * Say what Clerk is actually waiting for.
 *
 * `attemptEmailAddressVerification` resolving with a status other than
 * "complete" does not mean the code was wrong -- the code was accepted. It
 * means the instance wants more than an email address before it will create
 * the account: most often a password, because Password is still enabled in the
 * dashboard even when email codes are.
 *
 * The first version of this said "That code was not enough to finish signing
 * up", which is true and useless. It named neither the missing field nor the
 * setting responsible, so the only way to find out was to read Clerk's state
 * by hand -- which is exactly what happened.
 */
export interface IncompleteAttempt {
  status?: string | null;
  missingFields?: string[];
  unverifiedFields?: string[];
}

export function explainIncomplete(result: IncompleteAttempt): string {
  const missing = [...(result.missingFields ?? []), ...(result.unverifiedFields ?? [])];

  if (missing.length > 0) {
    const readable = missing.map((f) => f.replace(/_/g, " ")).join(", ");
    return (
      `Your code was accepted, but this Clerk instance also requires: ${readable}. ` +
      "Turn those off in the Clerk dashboard under User & Authentication, or collect them here."
    );
  }

  return (
    `Your code was accepted, but Clerk did not finish the sign-up (status: ${result.status ?? "unknown"}). ` +
    "Check what User & Authentication requires beyond an email address."
  );
}
